import React, { useState } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { config } from '../../../../config'

import { useAuth } from '../../../../data/hooks/auth'

import Button from '../../button'

type GoodreadsGuideProps = {
    onImportStarted?: () => void
    className?: string
}

const GoodreadsGuide: React.FunctionComponent<GoodreadsGuideProps> = ({ onImportStarted, className }) => {
    const [file, setFile] = useState<Blob | null>(null)
  const [error, setError] = useState<string | null>(null)

  const { token } = useAuth()

  const startImport = async () => {
    console.log("Import started", file)
    if (!file) {
      setError("Must select file!")
      return
    }

    const formData = new FormData()
    formData.append('file', file)

    fetch(`${config.api.urlV1}/library_import/goodreads/`, {
        method: "POST",
        headers: {
          token: token?.access!,
        },
        body: formData,
    })

    onImportStarted && onImportStarted()
  }

  return (
      <Container className={className}>
        <Title>This guide will explain to you how to import your library from Goodreads to Byzans</Title>
        <Section>
          Go to Goodreads Export page: 
          <Link href="https://www.goodreads.com/review/import" target="blank">Open the page in the new tab</Link>
        </Section>

        <Section>
          Press "Export Library" button there. After you do that, the link to download your export file should appear below that button. 
          Depending on the size of your library it may take some time to appear.
        </Section>

        <Section>
          Upload the exported csv file here. You can also just drag and drop the file onto the window.
          <input type="file" onChange={(ev) => ev.target.files ? setFile(ev.target.files[0]) : null }/>
        </Section>

        <Section>
          Press the button below to start the import process. You can track your import progress in you profile page
          <Button onClick={startImport}>Let's go!</Button>
        </Section>

        { error && <Error>{error}</Error>}
      </Container>
  )
}


const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  grid-row-gap: 32px;

  padding: 24px 16px;

  background: ${p => p.theme.colors.bg};
  border-radius: 10px;

  ${up('tablet')} {
		padding: 48px 24px;
	}
`

const Title = styled.div`
  fonst-size: 16px;
  font-weight: bold;
`

const Section = styled.div`
  display: grid;

  width: 100%;

  padding: 20px;

  background: ${p => p.theme.colors.lightGray};
  border: 1px dashed ${p => p.theme.colors.darkGray};

  border-radius: 20px;
`

const Link = styled.a`
  background: ${p => p.theme.colors.accent};
  border: none;
  border-radius: 12px;

	padding: 17px;
	margin-top: 18px;
	width: 100%;

	font-weight: bold;

	font-size: 16px;
	line-height: 22px;
	text-align: center;

	cursor: pointer;

	position: relative;
	overflow: hidden;

  &, &:active {
		outline: none;
	}

  &, &:visited, &:active {
    text-decoration: none;
    color: ${p => p.theme.colors.bg};
  }
`

const Error = styled.div`
  color: red;
  font-size: 16px;
`

export default GoodreadsGuide